import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Operation } from '../_models/operation';
import { Period } from '../_models/period';
import { Project } from '../_models/project';
import { Solution } from '../_models/solution';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class SolutionService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  add(projectId: string, solution: Solution) {
    return this.http.post<Solution>(`${environment.apiUrl}/Solutions/${projectId}`, solution, { headers: this.authService.headers });
  }

  delete(solutionId: string) {
    return this.http.delete(`${environment.apiUrl}/Solutions/${solutionId}`, { headers: this.authService.headers });
  }

  update(solution: Solution) {
    return this.http.put<Solution>(`${environment.apiUrl}/Solutions/${solution.id}`, solution, { headers: this.authService.headers });
  }

  get(solutionId: string) {
    return this.http.get<Solution>(`${environment.apiUrl}/Solutions/${solutionId}`, { headers: this.authService.headers });
  }

  getWaterList() {
    return this.http.get<any[]>(`${environment.apiUrl}/Solutions/Water`, { headers: this.authService.headers });
  }

  getBiodiversityList() {
    return this.http.get<any[]>(`${environment.apiUrl}/Solutions/Biodiversity`, { headers: this.authService.headers });
  }

  duplicate(resourceId: string) {
    return this.http.post<Solution>(`${environment.apiUrl}/Solutions/duplicate?id=${resourceId}`, null, { headers: this.authService.headers });
  }

  getAllGroupedByProject(versionId?: string) {
    var url = `${environment.apiUrl}/Solutions/GetAllGroupedByProject`;
    if (versionId) {
      url += `?versionId=${versionId}`;
    }
    return this.http.get<Project[]>(url, { headers: this.authService.headers });
  }

  addPeriodToSolution(solutionId: string, period: Period) {
    const payload = {
      name: period.name,
      listOperation: period.listOperation || []
    };
    return this.http.post<Period>(`${environment.apiUrl}/Solutions/${solutionId}/temporality`, payload, { headers: this.authService.headers });
  }

  updatePeriodOnSolution(solutionId: string, periodId: string, period: Period) {
    const payload = {
      temporalityId: periodId,
      name: period.name,
      listOperation: period.listOperation || []
    };
    return this.http.put<Period>(`${environment.apiUrl}/Solutions/${solutionId}/temporality/${periodId}`, payload, { headers: this.authService.headers });
  }

  duplicatePeriodOnSolution(solutionId: string, periodId: string) {
    return this.http.post<Period>(`${environment.apiUrl}/Solutions/${solutionId}/temporality/${periodId}/duplicate`, null, { headers: this.authService.headers });
  }

  copyOperationsToPeriod(solutionId: string, periodId: string, operationIds: string[]) {
    return this.http.post<Operation[]>(`${environment.apiUrl}/Solutions/${solutionId}/temporality/${periodId}/operations`, operationIds, { headers: this.authService.headers });
  }

  deletePeriodFromSolution(solutionId: string, periodId: string) {
    return this.http.delete(`${environment.apiUrl}/Solutions/${solutionId}/temporality/${periodId}`, { headers: this.authService.headers });
  }
}
